import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <span
    className={`text-xs md:text-sm uppercase tracking-[0.25em] font-bold mb-5 flex items-center gap-3 ${
      dark ? "text-[#0066FF]" : "text-cyan-400"
    }`}
  >
    <span className="h-px w-10 bg-current inline-block" />
    {children}
  </span>
);
